module.exports = __webpack_public_path__ + "static/media/selo_ooppah.153212ec.svg";